import React, { useEffect, useState } from 'react'
import Layout from '@/components/layout/Layout'
import MainHeading from '@/components/common/MainHeading'
import EmployeeProfileDetailView from '@/components/common/EmployeeProfileDetailView'
import { useAppSelector } from '@/store/store'
import EmployeeOnBoardService from '@/services/EmployeeOnBoard/EmployeeOnBoardService'
import { ThrowError } from '@/api/callApi'
import type { IEmployee } from '@/interface/employeeOnBoard'
import { Spinner } from '@/components/ui/spinner'

const Profile: React.FC = () => {
    const authUser = useAppSelector((state) => state.user.user);
    const [profile, setProfile] = useState<IEmployee | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const userId = authUser?.id;
        if (!userId) {
            setIsLoading(false);
            return;
        }

        const fetchProfile = async () => {
            try {
                setIsLoading(true);
                const response = await EmployeeOnBoardService.getEmployeeById(userId);
                if (response?.status && response?.data) {
                    setProfile(response.data);
                } else if (authUser) {
                    // Fallback to redux user if API response is not in standard shape
                    setProfile(authUser as unknown as IEmployee);
                }
            } catch (error) {
                console.error("Error fetching profile details:", error);
                // Fallback to redux user in case of error
                if (authUser) {
                    setProfile(authUser as unknown as IEmployee);
                } else {
                    ThrowError(error);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfile();
    }, [authUser?.id]);

    const displayData = profile || (authUser as unknown as IEmployee);

    if (isLoading && !displayData) {
        return (
            <Layout>
                <div className="flex items-center justify-center min-h-[400px]">
                    <Spinner className="h-8 w-8 text-primary animate-spin" />
                </div>
            </Layout>
        );
    }

    return (
        <Layout>
            <div className="space-y-6">
                <MainHeading
                    title="My Profile"
                    isBackButtonVisible={true}
                />
                <EmployeeProfileDetailView employee={displayData} />
            </div>
        </Layout>
    );
};

export default Profile;
